// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"463":"640ed0b3","543":"e8716a47","5459":"9cdf8768","5972":"2b94b7e9","6351":"1ac37c93","9933":"6806ca58"}[chunkId] + ".css";
};